<template>
  <v-menu
    offset-y
    attach
    :close-on-content-click="false"
    style="background: #404E55; width: 100%; max-width: 300px; height: 100%;"
    open-on-hover
    class="collectionPopupContainer"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-layout
        v-bind="attrs"
        v-on="on"
        align-center
        full-height
      >
        <v-flex xs1 mr-1 ml-1>
          <v-icon :color="mainColor">{{mainLens}}</v-icon>
        </v-flex>
        <v-flex xs8>
          <span class="caption font-weight-bold">WXP Collaboration Collector</span>
        </v-flex>
        <v-flex xs1>
          <v-btn text icon color="grey lighten-1" :loading="loading" @click="refreshStatus">
            <v-icon>far fa-sync</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <v-card width="300px" style="border: 0;">
      <v-card-text>
        <span v-if="!workerSessions || !workerSessions.length">
          The WXP Collaboration Collector is not detected. Please follow the instructions to setup, download and install or check connections.
        </span>
        <span v-if="!workerSessions || !workerSessions.length" class="subheading">
          <br/>What is the WXP Collaboration collector?
        </span>
        <span v-if="!workerSessions || !workerSessions.length">
          <br/>The WXP Collaboration data collector collects technical communication logs to us that provide our monitoring and analytic services.
          It requires constant network access and will always be running to ensure connectivity.
        </span>
        <v-expansion-panels rounded-0>
          <v-expansion-panel popout v-model="panels" v-for="(session) in workerSessions" :key="session.id">
            <v-expansion-panel-header>
              <v-layout align-center style="margin-left: -10px;">
              <v-flex>
                <v-icon :color="getLensColor(session)">fas fa-circle</v-icon>
              </v-flex>
              <v-flex>
                <span v-if="session.hostName || session.hostname" class="caption" style="white-space:nowrap;">{{session.hostName || session.hostname}} (v {{brokerVersion(session)}})</span>
                <span v-if="!session.hostName && !session.hostname" class="caption" style="white-space:nowrap;">v {{brokerVersion(session)}} </span>
              </v-flex>
              <v-flex v-if="session.minorVersion >= 4.4">
                <v-icon size="12" v-if="brokerConnected(session)">far fa-link</v-icon>
                <v-icon size="12" v-else color="error">far  fa-unlink</v-icon>
              </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="small-text">
              <v-card>
                <v-card-text>
                  <p>Service Account: {{getUserName(session.updatedBy)}}</p>
                  <p v-if="session.collectorDir">Collector Directory: {{session.collectorDir}}</p>
                  <p>Running Since: {{formatDateTime(session.startDate)}}</p>
                  <p>Last Updated: {{formatDateTime(session.updatedDate)}}</p>
                  <p v-if="session.defaultIpAddress">Machine IP: {{session.defaultIpAddress}}</p>
                  <p v-if="session.os">OS: {{session.os.includes('Windows') ? 'Windows' : session.os}}</p>
                  <p>
                    Platform Version: {{session.version}}
                  </p>
                    <p>AppType: {{session.appType}}</p>
                  <p>Session ID: {{session.id}}</p>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
export default {
  data() {
    return {
      panels: 0, // [true],
      loading: false,
      metricHeaders: [
        { text: "Source", value: "source" },
        { text: "System Id", value: "srcId" },
        { text: "Category", value: "category" },
        { text: "Metric", value: "metric" },
        { text: "Value", value: "value" }
      ]
    };
  },
  computed: {
    ...mapGetters("collectors", {
      collectors: "getCollectors",
      workerSessions: "getWorkerSessions",
      loadingMetrics: 'loadingMetrics',
      loadingCollectors: 'loadingCollectors',
      collectorsNotFound: 'collectorsNotFound',
      collectorConnectionFailed: 'collectorConnectionFailed',
      collectorsLoaded: 'collectorsLoaded'
    }),
    collectorStatus: {
      get() {
        if (this.loadingCollectors) {
          return 'Attempting to find and connect to collectors'
        } else if (this.collectorsNotFound) {
          return 'No collectors found'
        } else if (this.collectorConnectionFailed) {
          return 'Unable to connect to collectors (click to retry)'
        } else if (this.collectorsLoaded) {
          return 'Connected to collectors'
        }
      }
    },
    ...mapGetters("user", {
      orgContext: "getOrgContext",
      isSU: "isSU",
      allUsers: 'activeUsers'
    }),
    hasCollector: {
      get() {
        return !_.isEmpty(this.collectors);
      }
    },
    mainColor: {
      get() {
        if (!this.workerSessions || !this.workerSessions.length) {
          return "#ffffff"
        } else {

          const alarms = _.find(this.workerSessions, {isAlarm: true})
          if (alarms) {
            return "error"
          }

          const stale = _.find(this.workerSessions, {isStale: true})
          if (stale) {
            return "warn"
          }

          return "success"
        }
      }
    },
    mainLens: {
      get() {
        if (!this.workerSessions || !this.workerSessions.length) {
          return "fal fa-circle"
        }
        return "fas fa-circle"
      }
    }
  },
  async created() {
    this.loading = true;
      await this.$store.dispatch('user/getAllUsers')
      await this.$store.dispatch("collectors/getWorkerSessions")
      if (await this.$store.dispatch('collectors/getCollectors')) {
        this.$store.dispatch("collectors/getMetrics")
      }
    this.panels = 0
    this.loading = false;
  },
  methods: {
    formatDateTime(val) {
      return moment(val).format("MM/DD/YYYY, h:mm:ss a");
    },
    formatUpTime(val) {
      return val / 1000;
    },
    getLensColor(session) {
      return session.isActive ? 'success' : (session.isStale ? 'warn' : 'error')
    },
    async refreshStatus() {
      this.loading = true;
      await this.$store.dispatch("collectors/getWorkerSessions")
      if (await this.$store.dispatch('collectors/getCollectors')) {
        this.$store.dispatch("collectors/getMetrics")
        this.$store.dispatch('collectors/getDrivers', true)
      }
      this.loading = false;
    },
    getUserName(userId) {
      if (!this.allUsers || !this.allUsers.length) {
        return userId
      }

      const user = _.find(this.allUsers, {id: userId})

      if (!user) {
        return userId
      }
      return user.login
    },
    brokerConnected(session) {
      if (!this.collectorsLoaded) {
        return false
      }
      const userName = this.getUserName(session.updatedBy)
      const hostName = session.hostName
      return !!_.find(this.collectors, {userName, hostName})
    },
    brokerVersion(session) {
      if (!this.collectorsLoaded) {
        return session.mainVersion
      }
      const userName = this.getUserName(session.updatedBy)
      const hostName = session.hostName
      const colItem = _.find(this.collectors, {userName, hostName})
      if (!colItem || !colItem.wdversion || _.isEmpty(colItem.wdversion)) {
        return null
      }
      return colItem.wdversion.major + '.' + colItem.wdversion.minor + '.' + colItem.wdversion.revision
    }
  },
  watch: {
    orgContext: async function(val) {
      if (!val) {
        return;
      }

      this.loading = true;
      await this.$store.dispatch('user/getAllUsers')
      await this.$store.dispatch("collectors/getWorkerSessions")
      if (await this.$store.dispatch('collectors/getCollectors')) {
        this.$store.dispatch("collectors/getMetrics")
        this.$store.dispatch('collectors/getDrivers', true)
      }
      this.loading = false;
    }
  }
};
</script>
<style scoped>
  .tooltip {
    overflow: hidden;
  }
  .collectionPopupContainer > div {
    border: 0;
    max-height: 600px;
    overflow-y: auto;
    margin-left: -15px;
  }
  .subheading {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .word-wrap {
    word-wrap: break-word;
  }
  .far.fa-sync {
    font-size: 18px;
  }
  .small-text .v-card__text {
    font-size: 10px;
    line-height: 12px;
  }
  .grey--text.text--lighten-1 {
    color: #bdbdbd;
    caret-color: #bdbdbd;
  }
</style>
